import { createToken, useEventChat } from "@event-chat/core";
import { forwardRef, useImperativeHandle, useMemo } from "react";
import { useFormEvent } from "./utils.js";
const isDefined = (value)=>void 0 !== value;
const convertPath = (path)=>('object' == typeof path ? [
        ...path
    ] : [
        path
    ]).filter(isDefined);
const InputInner = ({ name, callback, onChange, ...props }, ref)=>{
    const { group, parent } = useFormEvent();
    const fieldName = useMemo(()=>{
        const itemName = convertPath(name);
        const namePaths = convertPath(parent).concat(itemName);
        return (0 === namePaths.length ? [
            createToken('input-name')
        ] : void 0) ?? (1 === namePaths.length && 'object' != typeof name ? name ?? namePaths : namePaths);
    }, [
        name,
        parent
    ]);
    const result = useEventChat(fieldName, {
        ...props,
        callback: (record)=>{
            callback?.(record, result);
            onChange?.(record.detail, result);
        },
        group
    });
    useImperativeHandle(ref, ()=>({
            emit: result.emit
        }), [
        result
    ]);
    return null;
};
const FormInput = /*#__PURE__*/ forwardRef(InputInner);
if ('production' !== process.env.NODE_ENV) FormInput.displayName = 'FormInput';
const src_FormInput = FormInput;
export { src_FormInput as default };
